module.exports = __webpack_public_path__ + "static/media/sposobyKomunikacji.7b593f2e.png";